import { Badge } from "@similarweb/ui-components";

export const PreviewBadge = () => {
    return <Badge type="alpha">Preview</Badge>;
};
